import { ReactNode } from 'react'
import { Provider as UrqlProvider } from 'urql'

import { useCreateClient, UseCreateClientProps } from './useCreateClient'

interface GraphqlProviderProps extends UseCreateClientProps {
  children: ReactNode
}

export const GraphqlProvider = (props: GraphqlProviderProps) => {
  const client = useCreateClient(props)

  if (!client) {
    return null
  }

  return <UrqlProvider value={client} {...props} />
}
